(ns iris.subs
  (:require
   [re-frame.core :as re-frame]
   [clojure.string :as string]
   [iris.routes :as routes]))

(re-frame/reg-sub
 ::name
 (fn [db]
   (:name db)))

;; (re-frame/reg-sub
;;  ::active-panel
;;  (fn [db _]
;;    (:active-panel db)))

(re-frame/reg-sub
 ::active-panel
 (fn [db _]
   (get-in db [:route :panel])))

(re-frame/reg-sub
 ::route-params
 (fn [db _]
   (get-in db [:route :route :route-params])))

(re-frame/reg-sub
 ::handler
 (fn [db _]
   (get-in db [:route :route :handler])))

(re-frame/reg-sub
 ::mirror-hrefs
 :<- [::handler]
 :<- [::route-params]
 :<- [::anchor-params]
 (fn [[handler route-params anchor-params] _]
   (routes/mirror-hrefs handler route-params anchor-params)))

;; ns
(re-frame/reg-sub
 ::query-params
 (fn [db _]
   (get-in db [:route :route :query-params])))

(re-frame/reg-sub
 ::anchor-params
 (fn [db _]
   (get-in db [:route :route :anchor-params])))

(re-frame/reg-sub
 ::re-pressed-example
 (fn [db _]
   (:re-pressed-example db)))


(re-frame/reg-sub
 ::loading
 (fn [db]
   (:loading db)))

(re-frame/reg-sub
 ::jwt
 (fn [db]
   (:jwt db)))

(re-frame/reg-sub
 ::fb-user
 (fn [db]
   (:fb-user db)))

(re-frame/reg-sub
 ::fb-auth-state
 (fn [db]
   (:fb-auth-state db)))

(re-frame/reg-sub
 ::raid-len
 (fn [db]
   (:raid-len db)))

(re-frame/reg-sub
 ::raids-cache-id
 (fn [db]
   (:raids-cache-id db)))

(re-frame/reg-sub
 ::raidpurger
 (fn [db]
   (:raidpurger db)))

;; (re-frame/reg-sub
;;  ::roles
;;  (fn [db]
;;    (:roles db)))

(re-frame/reg-sub
 ::jwt-payload
 (fn [db]
   (:jwt-payload db)))

(re-frame/reg-sub
 ::roles
 (fn [db]
   ;; Note: returning set
   (set (get-in db [:jwt-payload :roles]))))



(re-frame/reg-sub
 ::alerts-popup
 (fn [db]
   (get-in db [:alerts :popup])))

(re-frame/reg-sub
 ::alerts
 (fn [db]
   (get-in db [:alerts :data])))

(re-frame/reg-sub
 ::alerts-show-all
 (fn [db]
   (get-in db [:alerts :show-all])))

(re-frame/reg-sub
 ::fp
 (fn [db]
   (get-in db [:fp])))

(re-frame/reg-sub
 ::dfp
 (fn [db]
   (get-in db [:dfp])))

(re-frame/reg-sub
 ::mobile
 (fn [db]
   (:mobile db)))

(re-frame/reg-sub
 ::viewport-size
 (fn [db]
   (get-in db [:viewport-size])))

(re-frame/reg-sub
 ::scroll-top
 (fn [db]
   (get-in db [:scroll-top])))

(re-frame/reg-sub
 ::show-moderator-logs
 (fn [db]
   (get-in db [:show-moderator-logs])))

(re-frame/reg-sub
 ::show-search-bar
 (fn [db]
   (get-in db [:show-search-bar])))


;; (re-frame/reg-sub
;;  ::message
;;  (fn [db]
;;    (:message db)))



(re-frame/reg-sub
 ::messages
 (fn [db [_ mode & [arg]]]
   (let [messages (get db :messages [])
         capped   (take 100 messages)]
     (case mode
       :latest (first capped)
       :at     (nth capped arg nil)
       :all    capped
       nil))))



(re-frame/reg-sub
 ::message-bar-mode
 (fn [db _]
   (get-in db [:message-bar :mode])))

(re-frame/reg-sub
 ::message-bar-index
 (fn [db _]
   (get-in db [:message-bar :index])))

(re-frame/reg-sub
 ::message-bar-more-msgs
 (fn [db _]
   (get-in db [:message-bar :more-msgs])))

(re-frame/reg-sub
 ::message-bar-expanded?
 (fn [db _]
   (get-in db [:message-bar :expanded?])))










;; TODO: ::ws and ::ws-sync subs are duplicated here and in posts subs now
;; need to raise them to top level anyway and deduplicate
(re-frame/reg-sub
 ::ws
 (fn [db]
  ;;  (get-in db [:posts :ws])
   (:ws db)))

(re-frame/reg-sub
 ::ws-sync
 (fn [db]
  ;;  (get-in db [:posts :ws-sync])
   (:ws-sync db)))

;; TODO: because this is supposed to get WS from header ruid (/acme.TLO),
;;       same thing should be done with hashtags (/h/somehash.TLO)
;; 12/23/22 added for hashtags
(re-frame/reg-sub
 ::ws-or
 (fn [query-v]
   [(re-frame/subscribe [::route-params])
    (re-frame/subscribe [::ws])])
 (fn [[rp ws] query-v]
  ;;  (if (and (:header rp) (re-find #"^.+\.[A-Z]{3}$" (:header rp)))
  ;;    (subs (:header rp) (+ 1 (string/last-index-of (:header rp) ".")))
  ;;    ws)
   (cond (and (:header rp) (re-find #"^.+\.[A-Z]{3}$" (:header rp)))
         (subs (:header rp) (+ 1 (string/last-index-of (:header rp) ".")))
         (and (:tag rp) (re-find #"^.+\.[A-Z]{3}$" (:tag rp)))
         (subs (:tag rp) (+ 1 (string/last-index-of (:tag rp) ".")))
         :else
         ws)))


(re-frame/reg-sub
 ::job-keywords
 (fn [db [_ k]]
   (get-in db [:job-keywords k])))

;; NEW: Online users subscriptions
(re-frame/reg-sub
 :online-users
 (fn [db _]
   (:online-users db #{})))

(re-frame/reg-sub
 :online-users-count
 :<- [:online-users]  ;; Use signal from :online-users sub
 (fn [online-users _]
   (count online-users)))
